module.exports = __webpack_public_path__ + "static/img/desplazamientos-3.ada7e40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/desplazamientos-3.jpg
// module id = W8dY
// module chunks = 1